import React, { useContext } from 'react';
import { string, number, func, bool } from 'prop-types';
import { translate, Trans } from 'react-i18next';
import classnames from 'classnames/bind';

import { Button } from '@snapask/common-components';

import ContextStore from '@dragonfruit/services/createContext.js';

import { quotaParser } from '@dragonfruit/utils/quotaParser';

import styles from './Subscription.scss';
import { getSubscriptionPriceInfo } from '@dragonfruit/utils/priceUnit';
const cx = classnames.bind(styles);

function Subscription({
  name,
  description,
  highlight,
  quota,
  currency,
  displayCurrency,
  price,
  planType,
  hasMorePlans,
  paymentMethodId,
  billingCyclePerMonths,
  designatedQuestion,
  contractPeriod,
  isContract,
  t,
}) {
  const { goToPurchasePage } = useContext(ContextStore);

  const handleGoToPurchase = () => goToPurchasePage(paymentMethodId);

  const {
    displayPrice,
    displayPriceUnit,
    subscriptionDescription,
  } = getSubscriptionPriceInfo({
    billingCyclePerMonths,
    planType,
    contractPeriod,
    isContract,
    price,
    currency,
    displayCurrency,
  });

  const getSessionText = quotaNumber =>
    quotaNumber <= 1
      ? t('premium.subscriptions.quotaUnit')
      : t('premium.subscriptions.quotaUnit_plural');

  const ctaButtonText = hasMorePlans
    ? t('premium.subscriptions.purchaseMorePlanButtonText')
    : t('premium.subscriptions.purchaseButtonText');

  const sessionText = `${quotaParser(quota)} ${getSessionText(
    quota
  )} ${displayPriceUnit}`;

  const planBenefits = t('premium.subscriptions.benefits', {
    returnObjects: true,
    defaultValue: [],
    designatedQuestion,
  }).filter(benefit => benefit !== '-');

  return (
    <div className={cx(styles.root, { highlight })}>
      {highlight && <h6 className={styles.label}>{highlight}</h6>}
      <div className={styles.content}>
        <h2 className={styles.name}>{name}</h2>
        <p className={styles.description}>{description}</p>

        <h4 className={styles.price}>
          <Trans i18nKey="premium.priceDisplayFormat">
            Price
            <div className={styles.symbol}>{{ symbol: displayCurrency }}</div>
            <div>{{ number: displayPrice }}</div>
          </Trans>
          <div className={styles.unit}>{displayPriceUnit}</div>
        </h4>

        <div className={styles.subscriptionDescription}>
          {subscriptionDescription}
        </div>
        <div className={styles.ctaButton}>
          <Button
            disabled={!paymentMethodId}
            onClick={handleGoToPurchase}
            text={ctaButtonText}
          />
        </div>
        <div className={styles.quota}>{sessionText}</div>

        <ul className={styles.benefits}>
          {planBenefits.map((benefits, index) => (
            <li key={index} className={styles.benefitsItem}>
              {benefits}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

Subscription.propTypes = {
  billingCyclePerMonths: number.isRequired,
  contractPeriod: number.isRequired,
  currency: string.isRequired,
  designatedQuestion: number.isRequired,
  displayCurrency: string.isRequired,
  hasMorePlans: bool.isRequired,
  isContract: bool.isRequired,
  name: string.isRequired,
  paymentMethodId: number.isRequired,
  planType: string.isRequired,
  price: number.isRequired,
  t: func.isRequired,
  description: string,
  highlight: string,
  quota: number,
};

Subscription.defaultProps = {
  description: null,
  highlight: null,
};

export default translate(['premium'])(Subscription);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/Subscription/Subscription.jsx